import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("jc_token");
    const cached = localStorage.getItem("jc_user");
    if (token && cached) {
      setUser(JSON.parse(cached));
      api
        .get("/auth/me")
        .then((r) => {
          setUser(r.data);
          localStorage.setItem("jc_user", JSON.stringify(r.data));
        })
        .catch(() => {
          localStorage.removeItem("jc_token");
          localStorage.removeItem("jc_user");
          setUser(null);
        })
        .finally(() => setReady(true));
    } else {
      setReady(true);
    }
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("jc_token", data.token);
    localStorage.setItem("jc_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("jc_token");
    localStorage.removeItem("jc_user");
    setUser(null);
  };

  const MANAGER_ROLES = ["owner", "installation_manager", "assistant_installation_manager"];
  const canDelete = user && MANAGER_ROLES.includes(user.role);
  const isManager = canDelete;

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, canDelete, isManager }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
